import { render, staticRenderFns } from "./Azioni.vue?vue&type=template&id=78d58334"
import script from "./Azioni.vue?vue&type=script&lang=js"
export * from "./Azioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports